import type { ReactNode } from 'react'

/**
 * Shared page-header label, e.g. "- COURSES -".
 * Uses the same `section-eyebrow` style as the home page so every page matches.
 */
export function PageHeroEyebrow({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <p className={`section-eyebrow section-eyebrow-centered ${className}`}>{children}</p>
}

/** Page title: same typeface, weight and colour as the home page section titles, one size larger. */
export const pageHeroTitleClass = 'type-section-title md:text-5xl lg:text-[3.25rem] ncp-gradient-text'

/** Lead paragraph under a page title (matches home page section leads). */
export const pageHeroLeadClass = 'type-section-lead mx-auto'
